<div *ngIf="!isConnected" class="mt-4 mb-4 col-md-12" style="  background-color:red; color:white; text-align:center">
    Pas de connection internet
</div>